/**
 * PaymentDataKind enum
 */
export enum PaymentDataKindEnum {
  card = "card",
  cash = "cash",
  transfer = "transfer",
}
